'use strict';
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead from "./app.pages.-App-Page$-Chats-Read.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead$002dOf$002dDrug$002dRequest$002dFor$002dGeneral$002dPractice from "./app.pages.-App-Page$-Chats-Read-Of-Drug-Request-For-General-Practice.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead$002dOf$002dDrug$002dRequest$002dFor$002dPharmacy from "./app.pages.-App-Page$-Chats-Read-Of-Drug-Request-For-Pharmacy.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dHas$002dChat$002dId from "./app.pages.-App-Page$-Has-Chat-Id.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$HasChatId$() {
}
export { $c_Lapp_pages_AppPage$HasChatId$ as $c_Lapp_pages_AppPage$HasChatId$ };
$c_Lapp_pages_AppPage$HasChatId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$HasChatId$.prototype.constructor = $c_Lapp_pages_AppPage$HasChatId$;
/** @constructor */
function $h_Lapp_pages_AppPage$HasChatId$() {
}
export { $h_Lapp_pages_AppPage$HasChatId$ as $h_Lapp_pages_AppPage$HasChatId$ };
$h_Lapp_pages_AppPage$HasChatId$.prototype = $c_Lapp_pages_AppPage$HasChatId$.prototype;
$c_Lapp_pages_AppPage$HasChatId$.prototype.unapply__Lapp_pages_AppPage__s_Option = (function(v) {
  if ($j_app$002epages$002e$002dApp$002dPage$0024$002dHas$002dChat$002dId.$is_Lapp_pages_AppPage$HasChatId(v)) {
    var value = v.id__Ljkugiya_ulid_ULID();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lapp_pages_AppPage$HasChatId$.prototype.ordinal__Lapp_pages_AppPage$HasChatId__I = (function(x$0) {
  if ((x$0 instanceof $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead$002dOf$002dDrug$002dRequest$002dFor$002dGeneral$002dPractice.$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice)) {
    return 0;
  }
  if ((x$0 instanceof $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead$002dOf$002dDrug$002dRequest$002dFor$002dPharmacy.$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy)) {
    return 1;
  }
  if ((x$0 instanceof $j_app$002epages$002e$002dApp$002dPage$0024$002dChats$002dRead.$c_Lapp_pages_AppPage$ChatsRead)) {
    return 2;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lapp_pages_AppPage$HasChatId$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lapp_pages_AppPage$HasChatId__I(x);
});
var $d_Lapp_pages_AppPage$HasChatId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$HasChatId$, "app.pages.AppPage$HasChatId$", ({
  Lapp_pages_AppPage$HasChatId$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_pages_AppPage$HasChatId$ as $d_Lapp_pages_AppPage$HasChatId$ };
var $n_Lapp_pages_AppPage$HasChatId$;
function $m_Lapp_pages_AppPage$HasChatId$() {
  if ((!$n_Lapp_pages_AppPage$HasChatId$)) {
    $n_Lapp_pages_AppPage$HasChatId$ = new $c_Lapp_pages_AppPage$HasChatId$();
  }
  return $n_Lapp_pages_AppPage$HasChatId$;
}
export { $m_Lapp_pages_AppPage$HasChatId$ as $m_Lapp_pages_AppPage$HasChatId$ };
//# sourceMappingURL=app.pages.-App-Page$-Has-Chat-Id$.js.map
